module.exports = __webpack_public_path__ + "static/media/NEWS_20191213_wildAstro.dd4bea58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_20191213_wildAstro.jpg
// module id = 175
// module chunks = 0